import { useQuery } from '@tanstack/react-query';

import { type EligibleCreditReversalsResponse, getEligibleCreditReversals } from '~/services/OrdersService';

export const creditReversalQueryKeys = {
  all: ['creditReversals'] as const,
  lists: () => [...creditReversalQueryKeys.all, 'list'] as const,
  list: (userId: string, page: number, limit: number) =>
    [...creditReversalQueryKeys.lists(), userId, page, limit] as const,
};

export function useGetEligibleCreditReversals(userId: string, page: number, limit: number, enabled = true) {
  return useQuery<EligibleCreditReversalsResponse>({
    queryKey: creditReversalQueryKeys.list(userId, page, limit),
    queryFn: ({ signal }) => getEligibleCreditReversals(userId, page, limit, signal),
    enabled: !!userId && enabled,
  });
}
